import * as React from 'react';

import {
  Backdrop,
  Box,
  CircularProgress,
  Theme,
  Typography,
} from '@mui/material';
import { SxProps } from '@mui/system';

interface FullScreenLoaderProps {
  open: boolean;
  message?: string;
}

export default function FullScreenLoader({
  open,
  message,
}: FullScreenLoaderProps) {
  const backdropSx: SxProps<Theme> = {
    color: '#e4e4e4',
    zIndex: (theme) => theme.zIndex.drawer + 1000,
  };

  return (
    <Backdrop sx={backdropSx} open={open} transitionDuration={300}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={2}
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
          padding: '20px',
          color: 'secondary.main',
        }}>
        <CircularProgress color="primary" />

        {message && (
          <Typography variant="body1" sx={{ mt: 2 }}>
            {message}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
}
